import { useEffect, useRef, useState } from 'react';
import { Alert } from 'antd';

function parseTimestamp(text: string): number | null {
  // Expecting ISO8601 or epoch ms
  const trimmed = text.trim();
  const asNumber = Number(trimmed);
  if (!isNaN(asNumber)) {
    return asNumber;
  }
  const date = new Date(trimmed);
  if (!isNaN(date.getTime())) {
    return date.getTime();
  }
  return null;
}

export function VersionUpdateBanner() {
  const [show, setShow] = useState(false);
  const pageLoadTimeRef = useRef(Date.now() / 1000);

  const poll = async () => {
    try {
      const res = await fetch('/last_released', { cache: 'no-store' });
      if (!res.ok) return;

      const text = await res.text();
      const releasedAt = parseTimestamp(text);
      if (releasedAt && releasedAt > pageLoadTimeRef.current) {
        setShow(true);
      }
    } catch {
      return;
    }
  };

  useEffect(() => {
    if (show) return;

    const interval = setInterval(poll, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [show]);

  if (!show) {
    return null;
  }
  return (
    <div className='sticky top-0 left-0 w-full z-50' style={{ zIndex: 10000 }}>
      <Alert
        message={
          <span>
            A new version of this site is available. Please{' '}
            <a
              className='underline'
              href='#'
              onClick={e => {
                e.preventDefault();
                window.location.reload();
              }}
            >
              refresh
            </a>{' '}
            to update before continuing.
          </span>
        }
        type='warning'
        banner
        className='h-12 font-bold flex items-center'
      />
    </div>
  );
}
